import { Redirect, Route, Switch } from 'react-router-dom'

import { CallbackDeliveriesPage } from '../callback-deliveries-page/CallbackDeliveriesPage'
import * as urls from '../common/urls'
import { DashboardFulfillmentOrdersPage } from '../dashboard-fulfillment-orders-page/DashboardFulfillmentOrdersPage'
import { DashboardPage } from '../dashboard-page/DashboardPage'
import { DashboardPaymentsPage } from '../dashboard-payments-page/DashboardPaymentsPage'
import { LegacyPlanSelectorInstallPage } from '../legacy-plan-selector-install-page/LegacyPlanSelectorInstallPage'
import { MailSettingsPage } from '../mail-settings-page/MailSettingsPage'
import { NewsPage } from '../news-page/NewsPage'
import { PartnersPage } from '../partners-page/PartnersPage'
import { PricingPlansPage } from '../pricing-plans-page/PricingPlansPage'
import { SellingPlanPage } from '../selling-plan-page/SellingPlanPage'
import { SellingPlansProductsPage } from '../selling-plan-products-page/SellingPlanProductsPage'
import { SellingPlansPage } from '../selling-plans-index-page/SellingPlansPage'
import { CustomerPortalSettingsPage } from '../settings-page/CustomerPortalSettingsPage'
import { SettingsPage } from '../settings-page/SettingsPage'
import { SubscriptionCreatePage } from '../subscription-create-page/SubscriptionCreatePage'
import { SubscriptionFlowPage } from '../subscription-flow-page/SubscriptionFlowPage'
import { SubscriptionPage } from '../subscription-page/SubscriptionPage'
import { SubscriptionsIndexPage } from '../subscriptions-index-page/SubscriptionsIndexPage'
import { CustomerPortalTranslationsPage } from '../translations-page/CustomerPortalTranslationsPage'
import { WidgetTranslationsPage } from '../translations-page/WidgetTranslationsPage'
import { WorkflowLogsPage } from '../workflow-logs-page/WorkflowLogsPage'
import { WorkflowPage } from '../workflow-page/WorkflowPage'
import { WorkflowsIndexPage } from '../workflows-index-page/WorkflowsIndexPage'
import { SaveBarContextProvider } from './SaveBarProvider'

export const PageSwitch = () => {
  return (
    <SaveBarContextProvider>
      <Switch>
        <Route path="/getting-started/customer-portal">
          <Redirect to={'/getting-started'} />
        </Route>
        <Route path="/getting-started/plan-selector">
          <Redirect to={'/getting-started'} />
        </Route>
        <Route path="/__dashboard">
          <DashboardPage />
        </Route>
        <Route path="/dashboard/news">
          <NewsPage />
        </Route>
        <Route path="/dashboard/payments">
          <DashboardPaymentsPage />
        </Route>
        <Route path="/dashboard/fulfillments">
          <DashboardFulfillmentOrdersPage />
        </Route>
        <Route path="/dashboard">
          <DashboardPage />
        </Route>
        <Route path="/plans/new">
          <SellingPlanPage />
        </Route>
        <Route path="/plans/:id/products">
          <SellingPlansProductsPage />
        </Route>
        <Route path="/plans/:id">
          <SellingPlanPage />
        </Route>
        <Route path="/plans">
          <SellingPlansPage />
        </Route>
        <Route path="/subscriptions/create">
          <SubscriptionCreatePage />
        </Route>
        <Route path="/subscriptions/:id">
          <SubscriptionPage />
        </Route>
        <Route path="/subscriptions">
          <SubscriptionsIndexPage />
        </Route>
        <Route path="/installation">
          <Redirect to="/getting-started" />
        </Route>
        <Route path="/snippets">
          <Redirect to={'/settings/legacy-plan-selector'} />
        </Route>
        <Route path="/settings/webhook-deliveries">
          <CallbackDeliveriesPage />
        </Route>
        <Route path="/settings/partners">
          <Redirect to={urls.partnersUrl} />
        </Route>
        <Route path="/settings/pricing-plans">
          <PricingPlansPage />
        </Route>
        <Route path="/settings/legacy-plan-selector">
          <LegacyPlanSelectorInstallPage />
        </Route>
        <Route path="/settings/translations">
          <WidgetTranslationsPage />
        </Route>
        <Route path="/settings">
          <SettingsPage />
        </Route>
        <Route path="/customer-portal-settings/emails/:mailType">
          <MailSettingsPage />
        </Route>
        <Route path="/customer-portal-settings/translations">
          <CustomerPortalTranslationsPage />
        </Route>
        <Route path="/customer-portal-settings">
          <CustomerPortalSettingsPage />
        </Route>
        <Route path="/news">
          <Redirect to={'/dashboard/news'} />
        </Route>
        <Route path="/workflows/create">
          <WorkflowPage />
        </Route>
        <Route path="/workflows/subscription-flows/create">
          <SubscriptionFlowPage />
        </Route>
        <Route path="/workflows/subscription-flows/:id">
          <SubscriptionFlowPage />
        </Route>
        <Route path="/workflows/logs">
          <WorkflowLogsPage />
        </Route>
        <Route path="/workflows/:id">
          <WorkflowPage />
        </Route>
        <Route path="/workflows">
          <WorkflowsIndexPage />
        </Route>
        <Route path="/partners">
          <PartnersPage />
        </Route>
        <Route path="/">
          <Redirect to="/dashboard" />
        </Route>
      </Switch>
    </SaveBarContextProvider>
  )
}
